import React, { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { useDispatch } from "react-redux";

import { getLangFlag } from "../../../../common/parameters";
import { get } from "../../../actions/general";
import { amazonHost } from "../../../paths";
import User from "../../../components/User";

import Instagram from "./instagram";
import {
    H2,
    StyledWhy,
    Wrapper,
    CategoryTitle,
    Language,
    FlagWrapper,
    Flag,
    Translators,
    UserWrapper,
    CategoryBox,
    Sentry,
    Bvk,
    PartnersPositioner,
    GraphicPositioner,
    KodalyIreland,
    Kam,
    Aikem,
    LastRow,
    Alexandra,
} from "./styles";
import messages from "./messages";

const groupByLanguages = (translators: any[]) => {
    const languages: string[] = [];
    translators.forEach(translator => {
        if (languages.indexOf(translator.language) === -1) {
            languages.push(translator.language);
        }
    });
    return languages.map(language => ({
        language,
        translators: translators.filter(translator => translator.language === language),
    }));
};

const Contributors = ({ isNativeApp = false }) => {
    const [languages, setLanguages] = useState<{
        isFetching: boolean,
        data: { language: string, translators: any }[]
    }
    >({ isFetching: true, data: [] });
    const [moderators, setModerators] = useState<any[]>([])
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(get("about-us/translators", (res: any) => {
            setLanguages({
                isFetching: false,
                data: groupByLanguages(res.data),
            });
        }));
        dispatch(get("about-us/top-moderators", (res: any) => {
            setModerators(res.data);
        }));
    }, []);
    return (
        <StyledWhy style={{
            ...(isNativeApp && {
                pointerEvents: "none"
            })
        }}>
            <H2>
                <FormattedMessage {...messages.h2} />
            </H2>
            <Wrapper>
                <CategoryTitle>
                    <FormattedMessage {...messages.translators} />
                </CategoryTitle>
                <CategoryBox>
                    {!languages.isFetching &&
                        languages.data.map(language => (
                            <Language key={language.language}>
                                <FlagWrapper>
                                    <Flag src={"/flags/" + getLangFlag(language.language) + ".png"} />
                                </FlagWrapper>
                                <Translators>
                                    {language.translators.map((translator: any) => (
                                        <UserWrapper key={translator.user._id}>
                                            <User huge user={translator.user} reversed />
                                        </UserWrapper>
                                    ))}
                                </Translators>
                            </Language>
                        ))}
                </CategoryBox>
                <CategoryTitle>
                    <FormattedMessage {...messages.moderators} />
                </CategoryTitle>
                <CategoryBox>
                    {moderators.map(moderator => (
                        <UserWrapper key={moderator._id}>
                            <User huge user={moderator} reversed />
                        </UserWrapper>
                    ))}
                </CategoryBox>
                <CategoryTitle>
                    <FormattedMessage {...messages.partners} />
                </CategoryTitle>
                <CategoryBox>
                    <PartnersPositioner>
                        <a href="https://kam.sg" target="_blank" rel="noopener noreferrer">
                            <Kam src={`${amazonHost}landing/kam.jpg`} />
                        </a>
                        <a href="https://kodaly.ie" target="_blank" rel="noopener noreferrer">
                            <KodalyIreland src={`${amazonHost}landing/kodaly-ie.png`} />
                        </a>
                        <a href="https://aikem.it" target="_blank" rel="noopener noreferrer">
                            <Aikem src={`${amazonHost}landing/aikem2.jpg`} />
                        </a>
                        <a href="https://sentry.io/welcome" target="_blank" rel="noopener noreferrer">
                            <Sentry src="https://sentry-brand.storage.googleapis.com/sentry-logo-black.svg" />
                        </a>
                        <a href="https://bvk.hu/" target="_blank" rel="noopener noreferrer">
                            <Bvk />
                        </a>
                    </PartnersPositioner>
                </CategoryBox>
                <LastRow>
                    <div>
                        <CategoryTitle>
                            <FormattedMessage {...messages.additionalGraphics} />
                        </CategoryTitle>
                        <CategoryBox>
                            <GraphicPositioner>
                                <a href="mailto:barcskinga@gmail.com">Barcs Kinga</a>
                            </GraphicPositioner>
                        </CategoryBox>
                    </div>
                    <div>
                        <CategoryTitle>
                            <FormattedMessage {...messages.singers} />
                        </CategoryTitle>
                        <CategoryBox>
                            <GraphicPositioner>
                                <a href="mailto:musicalamiavita@gmail.com">
                                    <Alexandra src={`${amazonHost}landing/alexandra.jpg`} />
                                    Somogyi Alexandra
                                </a>
                            </GraphicPositioner>
                        </CategoryBox>
                    </div>
                </LastRow>
            </Wrapper>
        </StyledWhy>
    );
};

export default Contributors;
